import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HomeLayoutFragment = styled.div`
  margin: 0 auto;
  width: 100%;
`;

export const HomeWelcomeContainer = styled.div`
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 4px 32px 0px #0000006e;
`;

export const HomeWelcomeDate = styled.span`
  font-style: normal;
  font-weight: 600;
`;

export const HomeWelcomeTitle = styled.h1`
  font-style: normal;
  font-weight: 600;
`;

export const HomeWelcomeQuickLinkBar = styled.div`
  display: flex;
  gap: 16px;
`;

export const HomeWelcomeQuickLink = styled(Link)`
  all: unset;
  padding: 12px 16px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  color: rgb(var(--content-base-default));

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.stroke.secondary};

  & span {
    line-height: 0;
  }

  & span svg,
  & svg {
    fill: rgb(var(--content-base-default));
  }

  &:hover {
    color: ${({ theme }) => theme.colors.text.dark};
    background: rgb(var(--_button-background-tertiary-hover));
    svg {
      fill: ${({ theme }) => theme.colors.text.dark};
    }
  }

  &:focus {
    background: rgb(var(--_button-background-tertiary-focus));
  }
`;

export const HomeServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(320px, 1fr));
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: minmax(auto, 1fr);
  }
`;

export const UICard = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  background: var(--_background_base_surface-2_subdued);
  border-radius: 4px;
  backdrop-filter: blur(10px);
  box-shadow: 0px 4px 4px 0px #00000040;

  & h2 {
    margin: 0;
  }
`;

export const UICardHeader = styled.h2`
  color: ${({ theme }) => theme.colors.text.white};

  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  margin: 0;
`;

export const CardLogo = styled.img`
  height: 24px;
  width: auto;
  margin-left: 0;
  margin-right: auto;
`;

export const UICardFooter = styled.div`
  margin-bottom: 0;
  margin-top: 16px;
`;

export const HomeServicesHeader = styled.h2`
  color: ${({ theme }) => theme.colors.text.white};
  font-style: normal;
  font-weight: 600;
  margin-bottom: 16px;
`;
